module.exports = __webpack_public_path__ + "img/404.3419e352.svg";